import {Component, OnInit, ChangeDetectionStrategy, afterNextRender} from '@angular/core';
import {GalleryService} from '@services/gallery.service';
import {Title} from '@angular/platform-browser';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {TitleComponent} from '@/app/shared/components/title/title.component';
import {GalleryCardComponent} from '@components/gallery-card/gallery-card.component';
import {NoContentComponent} from '@/app/shared/components/no-content/no-content.component';
import {LastVideosComponent} from '@components/last-videos/last-videos.component';
import {PageSelectorComponent} from '@/app/shared/components/page-selector/page-selector.component';
import {GalleryTiny} from '@/app/core/models/gallery';

@Component({
	selector: 'app-gallery',
	imports: [
		TitleComponent,
		TranslatePipe,
		GalleryCardComponent,
		NoContentComponent,
		LastVideosComponent,
		PageSelectorComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './gallery.component.html',
})
export class GalleryComponent implements OnInit {

	constructor(
		private readonly galleryService: GalleryService,
		private readonly titleService: Title,
		private readonly translate: TranslateService
	) {
		// afterNextRender ne s'exécute jamais côté serveur : accès à window sûr en SSR.
		afterNextRender(() => window.scrollTo({ top: 0, behavior: 'smooth' }));
	}

	galleries: GalleryTiny[] = [];
	page: number = 0;
	totalPages: number = 0;

	ngOnInit(): void {
		this.loadGalleries();
	}

	loadGalleries() {
		this.galleryService.getPaginatedGalleries(this.page).subscribe(response => {
			this.galleries = response.content;
			this.totalPages = response.totalPages;
		});
	}

	onPageChange(newPage: number) {
		this.page = newPage;
		this.loadGalleries();
	}
}
